Flup.service("isMobile", function (flup) {
   var that = this;
   that.Android = function () {
      return /Android/i.test(navigator.userAgent);
   };
   that.BlackBerry = function () {
      return /BlackBerry/i.test(navigator.userAgent);
   };
   that.iOS = function () {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
   };
   that.Opera = function () {
      return /Opera Mini/i.test(navigator.userAgent);
   };
   that.Windows = function () {
      return /IEMobile/i.test(navigator.userAgent) || /WPDesktop/i.test(navigator.userAgent);
   };
   that.any = function () {
      return !!(that.Android() || that.BlackBerry() || that.iOS() || that.Opera() || that.Windows());
   };
});